import { Preferences } from '@capacitor/preferences'
import { i18n } from '../plugins/i18n'

const KEY = 'auth_token'

export async function getAuthToken(): Promise<string | null> {
  const { value } = await Preferences.get({ key: KEY })
  return value
}

export async function setAuthToken(token: string): Promise<void> {
  if (!token) return Promise.reject(new Error(String(i18n.global.t('token-empty-error'))))
  await Preferences.set({
    key: KEY,
    value: token,
  })
}

export async function clearAuthToken(): Promise<void> {
  await Preferences.remove({ key: KEY })
}
